import { isDefined } from '@sgme/fp';
import { useContext } from 'react';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import {
  StopLossContext,
  useValidateStopLoss,
} from '@/App/tiles/orders/StopLossOrder/StopLossOrderCreationTile/stopLossContext';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectLimitPriceStopLoss, selectStopLossErrors } from '@/store/orders/stopLoss/selectors.ts';
import { useDebounce } from '@/utils/hooks/debounce.ts';

export const StopLossLimitPrice = () => {
  const { tileId, setIsModifyingField } = useContext(StopLossContext);
  const track = useTrackEvent();

  const value = useAppSelector((state) => selectLimitPriceStopLoss(state, tileId));
  const errors = useAppSelector((state) => selectStopLossErrors(state, tileId));

  const validateStopLoss = useValidateStopLoss();

  const handleLimitPriceChange = useDebounce((newValue: number | undefined) => {
    track('Order action', 'Limit price changed');
    validateStopLoss({
      limitPrice: newValue,
    });
  });

  const limitPriceError = errors?.limitPrice;

  return (
    <OrderRow labelId="order.fields.limitPrice.label">
      <OmsFieldErrorWrapper errors={limitPriceError}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          value={value}
          maxDecimals={9}
          onChange={handleLimitPriceChange}
          onFocus={() => setIsModifyingField(true)}
          onBlur={() => setIsModifyingField(false)}
          size="sm"
          data-e2e="limit-price"
          state={isDefined(limitPriceError) ? 'invalid' : undefined}
        />
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
